import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LayerDeleteButton } from "./EditorTileInspectorLayer";
import { AiFillDelete } from "react-icons/ai";
import { UiConstants } from "../../data/UiConstants";
const Container = styled.div.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__Container",
  componentId: "sc-b6co9q-0"
})(["width:100%;padding:4px;&:hover{background-color:", ";}border-bottom:1px solid black;"], UiConstants.COLOR_HOVER);
const FlexRow = styled.div.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__FlexRow",
  componentId: "sc-b6co9q-1"
})(["display:flex;flex-direction:row;"]);
const Input = styled.input.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__Input",
  componentId: "sc-b6co9q-2"
})(["accent-color:", ";&:focus{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}"], UiConstants.COLOR_SELECTION_HIGHLIGHT, UiConstants.COLOR_SELECTION_HIGHLIGHT);
const InputLabel = styled.label.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__InputLabel",
  componentId: "sc-b6co9q-3"
})(["margin-left:4px;"]);
const FlexColumn = styled.div.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__FlexColumn",
  componentId: "sc-b6co9q-4"
})(["display:flex;flex-direction:column;margin:3px;flex-grow:1;flex-shrink:0;"]);
const ViewDirectionLabel = styled.div.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__ViewDirectionLabel",
  componentId: "sc-b6co9q-5"
})(["margin-top:3px;"]);
const DeleteContainer = styled.div.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__DeleteContainer",
  componentId: "sc-b6co9q-6"
})(["float:right;"]);
const InputContainer = styled.div.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__InputContainer",
  componentId: "sc-b6co9q-7"
})(["margin:2px;flex-shrink:0;"]);
const NumberInput = styled.input.withConfig({
  displayName: "NPCSensorSingleTriggerPropertiesEditor__NumberInput",
  componentId: "sc-b6co9q-8"
})(["width:40px;&:focus{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}"], UiConstants.COLOR_SELECTION_HIGHLIGHT);
export const NPCSensorSingleTriggerPropertiesEditor = observer(props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(DeleteContainer, null, /*#__PURE__*/React.createElement(LayerDeleteButton, {
    onClick: () => props.onDeleteTrigger(props.viewTrigger)
  }, /*#__PURE__*/React.createElement(AiFillDelete, null))), /*#__PURE__*/React.createElement(FlexColumn, null, t("editor.npc_inspector_area_trigger_name"), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: props.viewTrigger.name,
    onChange: e => props.viewTrigger.setName(e.target.value)
  })), /*#__PURE__*/React.createElement(FlexColumn, null, t("editor.npc_inspector_range_of_view"), /*#__PURE__*/React.createElement(NumberInput, {
    type: "number",
    value: props.viewTrigger.rangeOfSight,
    onChange: e => props.viewTrigger.setRangeOfSight(+e.target.value)
  })), /*#__PURE__*/React.createElement(ViewDirectionLabel, null, t("editor.npc_inspector_view_direction")), /*#__PURE__*/React.createElement(FlexRow, null, /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    id: props.viewTrigger.$modelId + "-forward",
    checked: props.viewTrigger.directionForward,
    onChange: e => props.viewTrigger.setDirectionForward(!props.viewTrigger.directionForward)
  }), /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: props.viewTrigger.$modelId + "-forward"
  }, t("editor.npc_inspector_view_direction_forward"))), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    id: props.viewTrigger.$modelId + "-backward",
    checked: props.viewTrigger.directionBackward,
    onChange: e => props.viewTrigger.setDirectionBackward(!props.viewTrigger.directionBackward)
  }), /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: props.viewTrigger.$modelId + "-backward"
  }, t("editor.npc_inspector_view_direction_backward"))), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    id: props.viewTrigger.$modelId + "-left",
    checked: props.viewTrigger.directionLeft,
    onChange: e => props.viewTrigger.setDirectionLeft(!props.viewTrigger.directionLeft)
  }), /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: props.viewTrigger.$modelId + "-left"
  }, t("editor.npc_inspector_view_direction_left"))), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    id: props.viewTrigger.$modelId + "-right",
    checked: props.viewTrigger.directionRight,
    onChange: e => props.viewTrigger.setDirectionRight(!props.viewTrigger.directionRight)
  }), /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: props.viewTrigger.$modelId + "-right"
  }, t("editor.npc_inspector_view_direction_right")))), !props.isCurrentMapPartOfTheModule && /*#__PURE__*/React.createElement(FlexRow, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: props.viewTrigger.isModuleGate,
    onChange: () => props.viewTrigger.setIsModuleGate(!props.viewTrigger.isModuleGate)
  }), "\xA0", t("editor.element_is_module_gate_area_trigger"))));
});